import classNames from 'classnames/bind';
import commaNumber from 'comma-number';
import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Fence from './Fence';
import styles from './index.module.scss';

import actions from '@/actions';
import EmptyList from '@/components/ui/EmptyList';
import MorePanel from '@/components/ui/MorePanel';
import useHandlerWithMoveCheck from '@/hooks/useHandlerWithMoveCheck';
import EventEmitter from '@/libs/EventEmitter';

const cx = classNames.bind(styles);

const Fences = () => {
  const dispatch = useDispatch();
  const fences = useSelector((state) => state.mission.json.fences);
  const bodyRef = useRef();
  const { handleWithMoveCheck } = useHandlerWithMoveCheck();

  const toggleAll = (open) => {
    fences.forEach((fence) => {
      EventEmitter.publish(`fence/${fence.id}/toggle`, open);
    });
  };

  const deleteAll = () => {
    fences.forEach((fence) => {
      dispatch(actions.mission.mavlink.removeFence(fence.id));
    });
  };

  return (
    <div className={cx('container')}>
      <div className={cx('summary')}>
        <div className={cx('total')}>Total {commaNumber(fences.length)}</div>
        <MorePanel
          data={[
            { name: 'Open All', callback: () => toggleAll(true) },
            { name: 'Close All', callback: () => toggleAll(false) },
            { name: 'Delete All', callback: handleWithMoveCheck(deleteAll, false) },
          ]}
        />
      </div>
      <div ref={bodyRef} className={cx('body')}>
        {fences.length === 0 && (
          <div className={cx('empty')}>
            <EmptyList message="No items" />
          </div>
        )}
        {fences.length > 0 && (
          <div className={cx('inner')}>
            {fences.map((fence, index) => {
              return (
                <div key={fence.id} className={cx('item')}>
                  <Fence index={index} data={fence} />
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default Fences;
